import { formatUnits,  } from "viem";
import type { WEIString, } from "@bracket/types";

/**
 * @description Converts a bigint to a decimal number with the specified number of decimal places
 * @param {bigint} value - The bigint value to convert
 * @param {number} decimals - The number of decimal places to use
 * @returns {number} The value as a decimal number with the specified decimal places
 * @example
 * // Returns 1 (1000000000000000000n with 18 zeros removed)
 * numberify(1000000000000000000n, 18)
 * 
 * // Returns 123.45 (123450000000000000000n with 18 zeros removed)
 * numberify(123450000000000000000n, 18)
 */
export const numberify = (value: bigint|WEIString, decimals: number): number => {
	// return Number(typeof value === "bigint" ? value : BigInt(value)) / (10**decimals);
	return Number(formatUnits(BigInt(value), decimals));
}
